(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsDialogController', TabObjectsDialogController);

    TabObjectsDialogController.$inject = ['$timeout', '$state', '$scope', 'DataUtils', 'entity', 'TabObjects', 'TabObjectTypes', 'TabFleets', 'ParseLinks', 'AlertService', 'Geolocalization', 'TabObjectsConditions'];

    function TabObjectsDialogController($timeout, $state, $scope, DataUtils, entity, TabObjects, TabObjectTypes, TabFleets, ParseLinks, AlertService, Geolocalization, TabObjectsConditions) {
        var vm = this;
        vm.tabObjects = entity;
        vm.tabObjectTypes = [];
        vm.tabFleets = [];
        vm.timeZone = [];
        vm.objectTypePage = 0;
        vm.fleetPage = 0;
        vm.tabObjects.multipleCreation = false;
        vm.tabObjects.sequence = false;
        vm.tabObjects.pair = false;
        vm.defaultCondition;
        vm.charToSearch;
        vm.fleetToSearch;

        var isLoadingObjectTypes = false;
        var isLoadingFleets = false;
        var originalValue = {
            id: null
        };

        $scope.$watch(function() {
            return vm.tabObjects.multipleCreation;
        }, function(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                //recall map
                $timeout(function () {
                    Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
                });
            }
        });

        if ($state.current.name === 'tab-objects-edit') {
            vm.tabObjects.$promise.then(function (to) {
                originalValue = to.objectType;
                vm.filterFleets();
                $timeout(function () {
                    Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
                });
                var timeZoneSelected = {timeZone: vm.tabObjects.objectTimeZone};
                vm.tabObjects.timeZone = timeZoneSelected;
            });
            vm.tabObjectsConditions = TabObjectsConditions.query();
        } else {
            vm.defaultCondition = TabObjectsConditions.default();
            $timeout(function () {
                Geolocalization.initializeGoogleMap(vm.tabObjects, $scope);
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        //wait for tabObjects before loading gmap


        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectsUpdate', result);
            vm.isSaving = false;
            $state.go('tab-objects');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            var timeZ;
            if (vm.tabObjects.id !== null) {
                timeZ = vm.tabObjects.timeZone;
                vm.tabObjects.objectTimeZone = timeZ.timeZone;
                vm.tabObjects.objectAddata = angular.toJson(vm.tabObjects.objectAddata);
                TabObjects.update(vm.tabObjects, onSaveSuccess, onSaveError);
            } else {
                vm.tabObjects.condition = vm.defaultCondition;
                timeZ = vm.tabObjects.timeZone;
                vm.tabObjects.objectTimeZone = timeZ.timeZone;
                TabObjects.save(vm.tabObjects, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-objects');
        };

        vm.setObjectCertificate = function ($file, tabObjects, col) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabObjects[col] = base64Data;

                    });
                });
            }
        };

        vm.isOriginalValue = function () {
            if (vm.tabObjects.objectType && originalValue.id === vm.tabObjects.objectType.id)
                vm.editForm.objectType.$setPristine();
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.filterFleets = function () {
            vm.loadAllFleet();
        };

        vm.onChangeCoordsFunction = function () {
            Geolocalization.reverseGeocode(vm.tabObjects, $scope);
        };

        vm.onChangeAddressFunction = function () {
            Geolocalization.geocodeFromAddress(vm.tabObjects, $scope);
        };

        vm.loadAllTimeZone = function() {
            TabObjects.timeZones(onZoneSuccess, onZoneError);

            function onZoneSuccess(data){
                vm.timeZone = [];
                for (var i = 0; i < data.length; i++) {
                    var timeZ = {timeZone: data[i]};
                    vm.timeZone.push(timeZ);
                }
            }

            function onZoneError(){}
        };

        vm.loadAllFleet = function () {
            isLoadingFleets = true;

            TabFleets.query({
                page: vm.fleetPage,
                size: 20,
                query: vm.fleetToSearch,
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                isLoadingFleets = false;
                vm.fleetToSearch = "";
                vm.fleetLinks = ParseLinks.parse(headers('link'));
                vm.fleetTotalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    var exists = vm.tabFleets.some(function(item) {
                        return item.id === data[i].id;
                    });

                    if (!exists) {
                        vm.tabFleets.push(data[i]);
                    }
                }
            }

            function onError(error) {
                isLoadingFleets = false;
                AlertService.error(error.data.message);
            }
        };

        vm.loadPageFleet = function (page) {
            if (page <= vm.fleetLinks['last']) {
                vm.fleetPage = page;
                vm.loadAllFleet();
            }
        };

        vm.loadAllObjectType = function () {
            isLoadingObjectTypes = true;

            TabObjectTypes.query({
                query: vm.charToSearch,
                page: vm.objectTypePage,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                isLoadingObjectTypes = false;
                vm.charToSearch = "";
                vm.objectTypeLinks = ParseLinks.parse(headers('link'));
                vm.objectTypeTotalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    var exists = vm.tabObjectTypes.some(function(item) {
                        return item.id === data[i].id;
                    });

                    if (!exists) {
                        vm.tabObjectTypes.push(data[i]);
                    }
                }
            }

            function onError(error) {
                isLoadingObjectTypes = false;
                AlertService.error(error.data.message);
            }
        };

        vm.loadPageObjectType = function (page) {
            if (page <= vm.objectTypeLinks['last']) {
                vm.objectTypePage = page;
                vm.loadAllObjectType();
            }
        };

        vm.convertToBoolean = function () {
            vm.tabObjects.sequence = vm.mode === "1";
        };

        vm.populateName = function () {
            vm.tabObjects.objectName = vm.tabObjects.objectUniqueCode;
        };

        vm.serachObjectType = function (search){
            if (isLoadingObjectTypes) return;
            vm.tabObjectTypes = [];
            vm.charToSearch = search;
            vm.objectTypePage = 0;
            vm.loadAllObjectType();
        }

        vm.searchFieldFleet = function (search){
            if (isLoadingFleets) return;
            vm.tabFleets = [];
            vm.fleetToSearch = search;
            vm.loadAllFleet();
        }

        // vm.loadAllObjectType();
        vm.loadAllTimeZone();

    }

})();
